import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './style.scss';
import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Input from '../../ui/Input';
import { useAppDispatch } from '../../store';
import Button from '../../ui/Button';
import { loginSuccess } from '../../store/adminSlices/auth';
import { login } from '../../api/admin/auth';
import { useNavigate } from 'react-router-dom';
import { APP_ROUTES } from '../../app.config.vars/routes';
import { useValidator } from '../../hooks/formValidator/useValidator';
import { isNotEmpty, isValidEmail } from '../../hooks/formValidator/validators';
import { useFocusOnFirstErrorField } from '../../hooks/errorFieldFocus';
const formValidationSchema = {
    email: [isNotEmpty, isValidEmail],
    password: [isNotEmpty],
};
const LoginForm = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const { formErrors, validateAll, validateInputField } = useValidator({
        inputSchema: formValidationSchema,
    });
    const orderedRefs = [
        ['email', useRef(null)],
        ['password', useRef(null)],
    ];
    const refs = Object.fromEntries(orderedRefs);
    const [loginStatus, setLoginStatus] = useState(null);
    const [forceFocus, setForceFocus] = useState(false);
    useFocusOnFirstErrorField(formErrors, orderedRefs, forceFocus, setForceFocus);
    const redirectRefLink = location.href.includes('ref') ? location.href.split('?ref=')[1] : null;
    const handleLogin = async () => {
        const errors = validateAll({ inputValues: { email, password } });
        if (Object.keys(errors).length > 0) {
            setForceFocus(true);
            return;
        }
        setLoginStatus('pending');
        try {
            const { token, refreshToken } = await login({ email, password });
            dispatch(loginSuccess({ token, refreshToken }));
            if (redirectRefLink) {
                navigate(redirectRefLink);
            }
            else {
                navigate(APP_ROUTES.adminManageRallies);
            }
        }
        catch (err) {
            setLoginStatus('error');
        }
    };
    return (_jsxs("form", { className: 'login-form', onSubmit: (event) => event.preventDefault(), children: [_jsx(Input, { ref: refs.email, id: 'email', name: "email", value: email, placeholder: t('placeholder.email'), onChange: (event) => {
                    setEmail(event.currentTarget.value);
                    validateInputField({ fieldName: 'email', value: event.currentTarget.value });
                }, error: !!formErrors.email?.length, errorMessage: !!formErrors.email?.length ? t(formErrors.email[0].messageTranslationKey) : undefined }), _jsx(Input, { ref: refs.password, id: 'password', value: password, type: "password", name: "password", placeholder: t('placeholder.password'), onChange: (event) => {
                    setPassword(event.currentTarget.value);
                    validateInputField({ fieldName: 'password', value: event.currentTarget.value });
                }, error: !!formErrors.password?.length, errorMessage: !!formErrors.password?.length
                    ? t(formErrors.password[0].messageTranslationKey)
                    : undefined }), loginStatus === 'error' && (_jsx("div", { className: "form-submit-error-message", children: t('admin.login_failed') })), _jsx("div", { className: "login-form-link", children: _jsx("a", { href: APP_ROUTES.adminForgotPassword, children: t('admin.forgot_password') }) }), _jsx("div", { className: "login-form-submit", children: _jsx(Button, { onClick: handleLogin, label: t('button.login'), disabled: loginStatus === 'pending' }) })] }));
};
export default LoginForm;
